import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, Link } from 'react-router-dom';
import { signUp } from '../../api';
import { useGame } from '../../context/GameContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiMail, FiLock, FiArrowRight, FiLoader } = FiIcons;

function SignUp() {
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { dispatch } = useGame();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await signUp(formData.email, formData.password, formData.name);
      dispatch({ type: 'AUTH_SUCCESS', payload: user });
      navigate('/parent');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-100 to-indigo-100"
    >
      <div className="max-w-md w-full bg-white rounded-[3rem] p-10 shadow-2xl border-4 border-blue-200">
        <div className="text-center mb-8">
          <div className="text-6xl mb-4">👨‍👩‍👧‍👦</div>
          <h1 className="text-3xl font-kid text-blue-700">Parent Signup</h1>
          <p className="font-comic text-blue-600">Create your account to add explorers!</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <SafeIcon icon={FiUser} className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-400" />
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Your Name"
              required
              className="w-full pl-12 pr-4 py-4 bg-blue-50 border-2 border-blue-100 rounded-2xl focus:outline-none focus:border-blue-400 font-comic"
            />
          </div>

          <div className="relative">
            <SafeIcon icon={FiMail} className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-400" />
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="Email Address"
              required
              className="w-full pl-12 pr-4 py-4 bg-blue-50 border-2 border-blue-100 rounded-2xl focus:outline-none focus:border-blue-400 font-comic"
            />
          </div>

          <div className="relative">
            <SafeIcon icon={FiLock} className="absolute left-4 top-1/2 -translate-y-1/2 text-blue-400" />
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="Create Password"
              required
              className="w-full pl-12 pr-4 py-4 bg-blue-50 border-2 border-blue-100 rounded-2xl focus:outline-none focus:border-blue-400 font-comic"
            />
          </div>

          {error && <div className="text-red-500 text-sm font-comic text-center bg-red-50 p-3 rounded-xl">{error}</div>}

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            disabled={loading}
            className="w-full bg-blue-500 text-white p-4 rounded-2xl font-kid text-xl shadow-lg flex items-center justify-center gap-2"
          >
            {loading ? <SafeIcon icon={FiLoader} className="animate-spin" /> : <>Create Account <SafeIcon icon={FiArrowRight} /></>}
          </motion.button>
        </form>

        <div className="mt-8 text-center font-comic text-blue-600">
          Already have an account? <Link to="/login" className="text-blue-700 font-bold underline">Login</Link>
        </div>
      </div>
    </motion.div>
  );
}

export default SignUp;